import React from 'react';
import {Container, Row, Col, Tab, Nav} from 'react-bootstrap';
import {ProjectList} from './ProjectList';
import 'animate.css';

export const Projects = () => {
    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col size={12}>
                        <div>
                            <h3>Projecten & Stages</h3>
                            <p>Bekijk hier de projecten die ik heb gedaan en de stages die ik gelopen heb!</p>
                            <Tab.Container id="projects-tabs" defaultActiveKey="technova">
                                <Nav variant="pills"
                                     className="nav-pills mb-5 justify-content-center align-items-center"
                                     id="pills-tab">
                                    <Nav.Item>
                                        <Nav.Link eventKey="technova">Technova College Ede</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="hu">Hogeschool Utrecht</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="others">Andere projecten</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="stages">Stages</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Row>
                                    <Col size={12}>
                                        <Tab.Content id="slideInUp">
                                            <Tab.Pane eventKey="technova">
                                                <Row>
                                                    <ProjectList type="projects" filter="technova"/>
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="hu">
                                                <Row>
                                                    <ProjectList type="projects" filter="hu"/>
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="others">
                                                <Row>
                                                    <ProjectList type="projects" filter="others"/>
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="stages">
                                                <Row>
                                                    <ProjectList type="stage"/>
                                                </Row>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
